{
  "clear": "Wyczyść",
  "invalid": "(nieprawidłowy)",
  "loading": "Wczytywanie...",
  "noResults": "Brak wyników"
}
